import { chartOption1 } from "./allTypeCharOptions/chartOption1"
export const home_differentOpt = [chartOption1]